<template>
  <bottom-bar-layout class="page-group-buy-create"
                   show-bar
                   :bar-height="164"
                   :is-show-guide-popup="false"
  >
    <group-buy-product class="group-buy-product"
                       :cover="product.cover"
                       :title="product.title"
                       :price="render.primaryPrice"
                       :team-size="activity.teamSize"
                       :product-id="product.id"
                       :product-type="product.productType"
    />

    <group-buy-rule :rule="activity.rule"
    />

    <template #tabbar>
      <div class="bottom">
        <row-item class="tip-tab-item"
                  type="gradient-highlight"
        >
          开团后{{ activity.duration }}自动结束
        </row-item>
        <!-- bottom bar -->
        <bottom-bar v-if="render.bottomBar.show"
                    :sell="activity.sell"
                    :product="joinProduct"
                    :action-bar="render.bottomBar.actionBar"
                    :my-team-id="myTeamId"
                    start-hint="开抢"
                    @disabledJoin="handleDisabledJoin"
        />
      </div>
    </template>


  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import GroupBuyProduct from '@/pages/GroupBuy/components/DetailProductBlock';
  import GroupBuyRule from '@/pages/GroupBuy/components/DetailRule';
  import { getGroupBuyActivity } from '@/services/groupGuy';
  import RowItem from '@/components/YmTabbarItem/Row';
  import BottomBar from '@/components/ProductDetailBottom/Bar';

  export default {
    name: 'GroupBuyCreate',
    metaInfo: {
      title: '发起拼团',
    },
    components: {
      BottomBarLayout,
      GroupBuyProduct,
      GroupBuyRule,
      RowItem,
      BottomBar,
    },
    data() {
      return {
        type: 'groupbuyTeam',
        product: {
          id: 0,
          cover: '',
          title: '',
          productType: '',
        },
        activity: {
          id: 0,
          duration: '',
          teamSize: 0,
          rule: '',
          sell: {
            startTime: '',
            status: '',
          },
        },
        myTeamId: 0,
        render: {
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
          },
        },
      };
    },
    computed: {
      joinProduct() {
        const { type, activity } = this;
        const { id } = activity;
        return {
          id,
          type,
          price: this.render.primaryPrice.origin.value,
        };
      },
    },
    methods: {
      async getActivityDetail(id) {
        const data = await getGroupBuyActivity(id);
        this.product = data.product;
        this.activity = data.activity;
        this.myTeamId = data.myTeamId;
        this.render = data.render;
      },
      handleDisabledJoin() {
        const { id } = this.activity;
        this.getActivityDetail(id);
      },
    },
    created() {
      this.getActivityDetail(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.getActivityDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-group-buy-create {
    .tip-tab-item {
      height: 44px;
      font-size: @font-size-small;
      text-shadow: @gradient-highlight-secondary-text-shadow;
    }
  }

  .group-buy-product {
    margin-bottom: @size-base;
  }

  .bottom {
    flex: 1;
  }

  .primary-tab-item {
    height: @tabbar-join-height;
  }
</style>
